
import TheButton from '@/components/TheButton.vue';
import authMixin from '@/mixins/authMixin';
import TheSelector from '@/components/TheSelector.vue';

export default({
    mixins: [authMixin],
    components: {
        TheButton,
        TheSelector
    },
    data() {
        return {
            authMode: "signin", // or "signup"
            submitBtnContent: "Sign In",
            authHeader: "Sign In",
            headerText: "Didn’t have an account?",
            alternativeOperation: "Sign Up",
            name: "",
            email: "",
            password: "",
            uniId: "",
            bio: "",
            department: "Communication",
            authResponse: ""
        }
    },
    methods: {
        syncDepartment(department){
            this.department = department;
        },
        switchToSignup(){
            this.$router.push({ name: "Signup" });
            this.authMode = "signup";
            this.authHeader = "Create An Account";
            this.headerText = "Already Have An Account?";
            this.submitBtnContent = "Sign Up";
            this.alternativeOperation = "Sign in";
        },
        switchToSignin(){
            this.$router.push({ name: "Signin" });
            this.authMode = "signin";
            this.authHeader = "Sign In";
            this.headerText = "Didn’t have an account?";
            this.submitBtnContent = "Sign In";
            this.alternativeOperation = "Sign up";
        },
        async signin(){
            if (!this.email || !this.password)  return;
            const res = await this.login ({ email: this.email, password: this.password })
            console.log(res);
            if (res.msg === 'success') {
                this.$store.commit("setPageMode", "questions");
                this.$router.push({ name: "Questions", params: { 'user_id': res.user.universityId } });

            } else {
                this.authResponse = res.msg;
            }
        },
                
        async createAccount(){
            if (!this.email || !this.password || !this.name || !this.uniId)  return;
            const res = await this.signup ({ email: this.email, password: this.password, name: this.name, universityId: this.uniId, department: this.department, bio: this.bio });
            console.log(res);
            if (res.msg === 'success') {
                this.$store.commit("setPageMode", "questions");
                this.$router.push({ name: "Questions", params: { 'user_id': res.user.universityId } });

            } else {
                this.authResponse = res.msg;
            }
            
        },
    }
})
